module.exports = __webpack_public_path__ + "img/logo-pse.7ed64f7a.png";